module.exports = __webpack_public_path__ + "assets/img/trust_4.82049454.png";